module.exports = new __parcel__URL__("gape_monke_empty.b6b3170f.png").toString();